import React, {
    useEffect,
    useState,
} from "react";

import "./LudoMatching.css";

const COMPUTER_NAMES = [
    "Alex",
    "John",
    "Mike",
    "David",
    "Chris",
    "Ryan",
    "Daniel",
    "Sam",
];

const COMPUTER_IMAGES = [
    "https://i.pravatar.cc/150?img=12",
    "https://i.pravatar.cc/150?img=15",
    "https://i.pravatar.cc/150?img=20",
    "https://i.pravatar.cc/150?img=25",
    "https://i.pravatar.cc/150?img=30",
    "https://i.pravatar.cc/150?img=35",
];

function LudoMatching({
    mode,
    playerProfiles,
    onComplete,
}) {

    const [
        visiblePlayers,
        setVisiblePlayers,
    ] = useState([]);

    const [
        countdown,
        setCountdown,
    ] = useState(null);


    const players =
        mode?.activePlayers || [];


    const humanColor =
        mode?.humanPlayer || "blue";


    useEffect(() => {

        let cancelled = false;

        const computerColors =
            players.filter(
                color =>
                    color !== humanColor
            );


        const human = {
            color: humanColor,
            name: "You",
            image:
                playerProfiles?.[
                    humanColor
                ]?.image ||
                "https://i.pravatar.cc/150?img=11",
            isHuman: true,
        };


        const computers =
            computerColors.map(
                (color, index) => {

                    const profile =
                        playerProfiles?.[
                            color
                        ];

                    return {
                        color,
                        name:
                            profile?.name ||
                            COMPUTER_NAMES[
                                index %
                                COMPUTER_NAMES.length
                            ],
                        image:
                            profile?.image ||
                            COMPUTER_IMAGES[
                                index %
                                COMPUTER_IMAGES.length
                            ],
                        isHuman: false,
                    };

                }
            );


        const allPlayers = [
            human,
            ...computers,
        ];


        // ------------------------------
        // PLAYER ANIMATION
        // ------------------------------

        allPlayers.forEach(
            (player, index) => {

                setTimeout(() => {

                    if (!cancelled) {

                        setVisiblePlayers(
                            current => [
                                ...current,
                                player,
                            ]
                        );

                    }

                }, 900 * index + 700);

            }
        );


        // ------------------------------
        // COUNTDOWN
        // ------------------------------

        const totalTime =
            900 *
            allPlayers.length +
            1800;


        setTimeout(() => {

            if (!cancelled) {
                setCountdown(3);
            }

        }, totalTime);


        setTimeout(() => {

            if (!cancelled) {
                setCountdown(2);
            }

        }, totalTime + 900);


        setTimeout(() => {

            if (!cancelled) {
                setCountdown(1);
            }

        }, totalTime + 1800);


        setTimeout(() => {

            if (!cancelled) {
                onComplete();
            }

        }, totalTime + 2700);


        return () => {
            cancelled = true;
        };

    }, []);


    return (

        <div className="ludo-matching">

            <div className="matching-card">

                <div className="matching-logo">
                    🎲
                </div>


                {countdown === null ? (

                    <>
                        <h1>
                            Finding Players
                        </h1>

                        <p>
                            Searching for opponents...
                        </p>
                    </>

                ) : (

                    <>
                        <h1>
                            Players Found
                        </h1>

                        <p>
                            Game starting in
                        </p>

                        <div className="matching-countdown">
                            {countdown}
                        </div>
                    </>

                )}


                <div className="matching-grid">

                    {players.map(
                        (color) => {

                            const player =
                                visiblePlayers.find(
                                    item =>
                                        item.color ===
                                        color
                                );

                            if (!player) {

                                return (

                                    <div
                                        key={color}
                                        className="matching-slot waiting"
                                    >

                                        <div>
                                            ?
                                        </div>

                                        <span>
                                            Waiting...
                                        </span>

                                    </div>

                                );

                            }


                            return (

                                <div
                                    key={color}
                                    className={`
                                        matching-slot
                                        joined
                                        ${color}
                                    `}
                                >

                                    <div className="matching-avatar">

                                        <img
                                            src={
                                                player.image
                                            }
                                            alt={
                                                player.name
                                            }
                                        />

                                    </div>

                                    <strong>
                                        {player.name}
                                    </strong>

                                    {/* <span>
                                        {player.isHuman
                                            ? "You"
                                            : "Computer"}
                                    </span> */}

                                </div>

                            );

                        }
                    )}

                </div>


                <div className="matching-progress">

                    {visiblePlayers.length}
                    {" / "}
                    {players.length}

                </div>


                <div className="matching-status">

                    {countdown === null
                        ? "Connecting players..."
                        : "All players ready ✓"}

                </div>

            </div>

        </div>

    );
}

export default LudoMatching;